import cloneDeep from 'lodash/cloneDeep'

import PoziAPIData from 'api/data'
import * as PoziUtils from 'api/utils'

/**
 * Pozi API Adapter
 */
function PoziAPICKANAPI () {
  // Adapters
  const adapters = {
    getDataAsGeoJSON: function (url) {
      return getDataAsGeoJSON(url)
    }
  }

  /**
   * Handle data requests
   */
  var getDataAsGeoJSON = function (url) {
    return new Promise(function (resolve, reject) {
      let err = ''

      if (!url) {
        err = 'PoziAPICKANAPI().getDataAsGeoJSON(url) Invalid URL'
        return reject(err)
      }

      console.log('PoziAPICKANAPI().getDataAsGeoJSON(url): ', url)

      PoziAPIData().ajax({
        timeout: 20000, // 10 second timeout,
        url,
        error: function (err) {
          console.log('PoziAPICKANAPI().getDataAsGeoJSON(url): ajax error: ', err)
          return reject(err)
        },
        success: function (ckanapiData) {
          handleCKANAPIFormat(ckanapiData)
            .then(function (geojson) {
              return resolve(geojson)
            })
            .catch(function (err) {
              console.log('handleCKANAPIFormat error: ', err)
              return reject(err)
            })
        }
      })
    })
  }

  /**
   * Handle data requests
   * @param gSheetData (string directly from google spreadsheets)
   * @return FeatureCollection
   */
  var handleCKANAPIFormat = function (data) {
    return new Promise(function (resolve, reject) {
      let err = ''

      console.log('handleCKANAPIFormat raw data', data)

      // Despite being a valid object data with invalid characters can cause OpenLayers to fail to render features.
      data = PoziUtils.cleanObjectOrString(data)

      let geoJSON = {
        type: 'FeatureCollection',
        totalFeatures: 0,
        features: [],
        crs: {
          type: 'name',
          properties: {
            name: 'urn:ogc:def:crs:EPSG::4326'
          }
        }
      }

      const feature = {
        type: 'Feature',
        id: '',
        properties: {}
      }

      // debug(JSON.stringify(json, null, 2))

      if (data.success === true && data.result && data.result.fields && data.result.records) {
        if (data.result.records.length === 0) {
          console.log('No records returned')
          return resolve(geoJSON)
        }

        // Figure out the keys.
        const keys = {}
        keys.id = ''
        keys.lat = ''
        keys.lng = ''

        for (const key in data.result.fields) {
          const field = data.result.fields[key]
          const s = field.id.toLowerCase()
          if (s === '_id') keys.id = field.id
          if (s === 'x' || s === 'lng' || s === 'lon' || s === 'long' || s === 'longitude') {
            keys.lng = field.id
          }
          if (s === 'y' || s === 'lat' || s === 'latitude') keys.lat = field.id
        }

        if (keys.id === '') {
          err = 'Unable to detect an id field. Checked for: _id'
          return reject(err)
        } /* else if (keys.lat === '') {
          err = 'Unable to detect the latitude. Checked for: y, lat, latitude'
          return reject(err)
        } else if (keys.lng === '') {
          err = 'Unable to detect lontitude in the data. Checked for: lng, lon, long, longitude'
          return reject(err)
        } */

        // console.log('keys: ', keys)
        let newFeature = {}

        try {
          let idAutoGenerated = 0
          for (const keyRecords in data.result.records) {
            const record = data.result.records[keyRecords]
            newFeature = cloneDeep(feature)

            // Add a geometry to the feature if it has valid coordinates
            if (keys.lng !== '' && keys.lat !== '') {
              const lng = Number(record[keys.lng])
              const lat = Number(record[keys.lat])
              newFeature.geometry = {
                coordinates: [lng, lat],
                type: 'Point'
              }
              newFeature.geometry_name = 'SHAPE' // do we need this?
            }

            if (keys.id === '') {
              idAutoGenerated = idAutoGenerated + 1
              newFeature.id = idAutoGenerated
              newFeature.properties.id = idAutoGenerated
            } else {
              newFeature.id = record[keys.id]
              newFeature.properties.id = record[keys.id]
            }

            for (const keyRecord in record) {
              if (Object.hasOwnProperty.call(record, keyRecord)) {
                newFeature.properties[keyRecord] = record[keyRecord]
              }
            }

            geoJSON.features.push(newFeature)
            geoJSON.totalFeatures++
          }
        } catch (e) {
          err = 'Error parsing data'
          return reject(err)
        }
      } else {
        err = 'Unable to find key properties to raw data.'
        return reject(err)
      }

      // Despite being a valid object data with invalid characters can cause OpenLayers to fail to render features.
      geoJSON = PoziUtils.cleanObjectOrString(geoJSON)

      console.log('CKANAPI converted geojson', geoJSON)

      return resolve(geoJSON)
    })
  }

  // Return adapters (must be at end of adapter)
  return adapters
}

export default PoziAPICKANAPI
// End A (Adapter)
